import React from 'react';

import { Text } from './Text';

export const TextBlock = ({ ...props }) => <Text {...{ ...props, as: 'p' }} />;
